export default {
    indexGeneralSettings:   { method: 'get',    url: 'general_settings' },
    showGeneralSetting:     { method: 'get',    url: 'general_settings/{id}'},
    createGeneralSetting:   { method: 'post',   url: 'general_settings'},
    updateGeneralSetting:   { method: 'put',    url: 'general_settings/{id}'},
    destroyGeneralSetting:  { method: 'delete', url: 'general_settings/{id}'},
}